import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-blue-custom py-2">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-2 mt-8">
          <div className="mx-auto" style={{ maxWidth: "165px" }}>
            <div>
              <iframe
                title="SRA Digital Badge"
                frameBorder="0"
                scrolling="no"
                allowtransparency="true"
                src="https://cdn.yoshki.com/iframe/55845r.html"
                style={{
                  border: "0px",
                  margin: "0px",
                  padding: "0px",
                  backgroundColor: "transparent",
                  top: "0px",
                  left: "0px",
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          </div>

          <div className="text-center md:text-left">
            <h4 className="font-bold text-purple mb-4">Services</h4>
            <ul className="text-sm space-y-2">
              <li>
                <Link
                  to="/services/family-law"
                  className="text-white/80 hover:text-white/50"
                >
                  Family Law
                </Link>
              </li>
              <li>
                <Link
                  to="/services/immigration-law"
                  className="text-white/80 hover:text-white/50"
                >
                  Immigration Law
                </Link>
              </li>
            </ul>
          </div>

          <div className="text-center md:text-left">
            <h4 className="font-bold text-purple mb-4">Company</h4>
            <ul className="text-sm space-y-2">
              <li>
                <Link
                  to="/our-people"
                  className="text-white/80 hover:text-white/50"
                >
                  Our People
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-white/80 hover:text-white/50"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/#contact"
                  className="text-white/80 hover:text-white/50"
                >
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          <div className="text-center md:text-left">
            <h4 className="font-bold text-purple mb-4">Legal</h4>
            <ul className="text-sm space-y-2">
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-white/80 hover:text-white/50"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-of-service"
                  className="text-white/80 hover:text-white/50"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/#contact"
                  className="text-white/80 hover:text-white/50"
                >
                  Complaints
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-300 pt-8 text-center">
          <p className="mb-6 text-sm text-white/80">
            &copy; 2026 Blackhorse Law. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
